import { XML_DECLARATION } from './ns';

const PROLOG = /^<\?xml[^>]*\?>\r?\n?/;

export function parseXml(text: string): Document {
  const doc = new DOMParser().parseFromString(text, 'application/xml');

  const error = doc.getElementsByTagName('parsererror')[0];
  if (error) {
    throw new Error(`Malformed XML part: ${error.textContent?.trim()}`);
  }

  return doc;
}

export function serializeXml(doc: Document, prolog: string = XML_DECLARATION): string {
  const body = new XMLSerializer().serializeToString(doc).replace(PROLOG, '');

  return prolog + body;
}

export function prologOf(text: string): string {
  return PROLOG.exec(text)?.[0] ?? XML_DECLARATION;
}
